import { Box, Chip } from '@mui/material';
import { formatFileImportLabel } from './fileImportFormatters';

const FileImportCountSummary = ({ counts }) => {
  const entries = Object.entries(counts || {});
  if (entries.length === 0) return '-';

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {entries.map(([key, value]) => (
        <Chip
          key={key}
          size='small'
          label={`${formatFileImportLabel(key)}: ${value}`}
        />
      ))}
    </Box>
  );
};

export default FileImportCountSummary;
